export default __webpack_public_path__ + "static/media/DoubleLayerMaterial.d2352eec.png";